import Session from '@/handler/session'
import { EventBus } from '@/handler/event-bus'

export default {
  data () {
    return {
      favicon: '',
      proyectName: '',
      primaryColor: ''
    }
  },
  created () {
    EventBus.$on('Settings:settings', () => {
      this.setup()
    })
  },
  mounted() {
    this.setup()      
  },  
  methods: {
    setup () {
      if(Session.getSession().settings) {
        this.favicon = Session.getSession().settings.favicon
        this.proyectName = Session.getSession().settings.proyect_name
        this.primaryColor = Session.getSession().settings.color_primary

        this.changeFavicon()
        this.changeTitle()
        this.createCSS()
      }
    },
    changeFavicon() {
      var link = null
      link = document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.favicon
      document.getElementsByTagName('head')[0].appendChild(link)
    },
    changeTitle() {
      document.title = this.proyectName

      var metas = document.getElementsByTagName("meta");

      for(var i=0;i<metas.length;i++){
        if(metas[i].getAttribute("name")=="apple-mobile-web-app-title") {
            metas[i].setAttribute("content",this.proyectName);
        }                    
      }
    },
    createCSS() {      
      var hoja = document.createElement('style')
      hoja.innerHTML = ""
      hoja.innerHTML = hoja.innerHTML  + ".primary-color { color: " + this.primaryColor + "; }"
      hoja.innerHTML = hoja.innerHTML  + ".primary-color:hover {color: " + this.primaryColor + "; filter:brightness(0.8);}"
      hoja.innerHTML = hoja.innerHTML  + ".primary-background { background: " + this.primaryColor + "; border-color: " + this.primaryColor + "; color: white; }"
      hoja.innerHTML = hoja.innerHTML  + ".primary-background:hover { background: " + this.primaryColor + "; border-color: " + this.primaryColor + "; color: white; filter:brightness(0.8); }";
      
      document.body.appendChild(hoja);
    },        
  }
}